import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWearosComponent } from './simple-icons-wearos.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWearosComponent ],
    exports:      [ SimpleIconsWearosComponent ],
    bootstrap:    []
})
export class SimpleIconsWearosModule {}
